<template>
    <div>
        <div class="b-paging-bar">
            <div class="b-paging-bar__page-size">
                <label for="input-press-page-size">
                    {{ appData.dictionary.resultsPerPage }}
                    <span class="b-paging-bar__results-count-mob">
                        {{ showingResultsFrom }} -
                        {{ showingResultsTo }}
                        {{ appData.dictionary.showingResultsOf }}
                        {{ resultsCount }}
                    </span>
                </label>
                <select id="input-press-page-size" v-model="pageSize" class="custom-select" @change="pageSizeUpdated">
                    <option v-for="(item, i) in appData.pageSizeOptions" :key="'page-size-' + i" :value="item">
                        {{ item }}
                    </option>
                </select>
            </div>
            <div class="b-paging-bar__results-count">
                {{ showingResultsFrom }} -
                {{ showingResultsTo }}
                {{ appData.dictionary.showingResultsOf }}
                {{ resultsCount }}
            </div>
            <div class="b-paging-bar__pagination">
                <Pagination :key="paginationUpdateKey" :total-pages="totalPages" @page-updated="pageUpdated" />
            </div>
        </div>
    </div>
</template>

<script>
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'
import Pagination from 'Root/vue/components/Pagination.vue'

export default {
    components: {
        Pagination,
    },

    props: {
        defaultPage: {
            type: Number,
            default: 1,
        },
        defaultPageSize: {
            type: Number,
            default: null,
        },
        resultsCount: {
            type: Number,
            default: 0,
        },
    },

    emits: ['paging-updated'],

    data() {
        return {
            pageSize: this.appData.pageSizeOptions[0],
            currentPage: 1,

            paginationUpdateKey: 0,
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.resultsCount / this.pageSize)
        },

        showingResultsFrom() {
            return this.pageSize * (this.currentPage - 1) + 1
        },

        showingResultsTo() {
            return Math.min(this.pageSize * this.currentPage, this.resultsCount)
        },
    },

    mounted() {
        this.currentPage = this.defaultPage
        this.pageSize = this.defaultPageSize

        this.$nextTick(() => {
            this.$el.querySelectorAll('.custom-select').forEach((elem) => {
                elem.CustomSelect = new CustomSelectUI(elem)
            })
        })
    },

    methods: {
        pageUpdated(page) {
            this.currentPage = page
            this.pagingUpdated()
        },
        pageSizeUpdated() {
            this.currentPage = 1
            this.paginationUpdateKey++

            this.pagingUpdated()
        },

        pagingUpdated() {
            this.$emit('paging-updated', {
                pageSize: this.pageSize,
                page: this.currentPage,
            })
        },
    },
}
</script>
